import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  UPDATE_COMMITMENTS_SUCCESS,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_LOAN_DETAIL_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
} from '../../actions/types'

const summary = (state={}, { type, payload }) => {
  switch(type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      if (payload.applicationFlow.loanDetail !== undefined) {
        return payload.applicationFlow.loanDetail.summary
      } else {
        return state
      }
    case UPDATE_LOAN_DETAIL_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case UPDATE_COMMITMENTS_SUCCESS:
    case UPDATE_ASSETS_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      if (payload.loanDetail !== undefined) {
        return payload.loanDetail.summary
      } else {
        return state
      }
    default:
      return state
  }
}

export default summary;
